document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* Accordion (product page) */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion-item');
      var wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('open');
        var t = i.querySelector('[data-accordion-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Product gallery thumbnails (plain click - just swap photo) */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-gallery]');
      var mainImg = gallery.querySelector('[data-gallery-main-img]');
      var newSrc = thumb.getAttribute('data-full-src');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
        mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
      }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  /* Quantity selector */
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
      });
    }
  });

  /* Variant selection: update price, image, availability, hidden variant id input */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantDataEl = form.querySelector('[data-variant-json]');
    if (!variantDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      variants = [];
    }

    var productInfo = form.closest('.product-info');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceNow = productInfo ? productInfo.querySelector('[data-price-now]') : null;
    var priceWas = productInfo ? productInfo.querySelector('[data-price-was]') : null;
    var stockMsg = productInfo ? productInfo.querySelector('[data-stock-msg]') : null;
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var galleryEl = productInfo && productInfo.parentElement ? productInfo.parentElement.querySelector('[data-gallery]') : null;

    function optionInputs() {
      return Array.from(form.querySelectorAll('input[type="radio"][data-option-index]:checked'));
    }

    function currentSelection() {
      var sel = [];
      optionInputs().forEach(function (input) {
        sel[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return sel;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var a = (opt || '').trim().toLowerCase();
          var b = (sel[i] || '').trim().toLowerCase();
          return a === b;
        });
      });
    }

    function findVariantById(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function selectRadiosForVariant(variant) {
      form.querySelectorAll('input[type="radio"][data-option-index]').forEach(function (radio) {
        var idx = parseInt(radio.getAttribute('data-option-index'), 10);
        var wanted = (variant.options[idx] || '').trim().toLowerCase();
        var val = (radio.value || '').trim().toLowerCase();
        radio.checked = (val === wanted);
      });
    }

    function updateUI(isInitialLoad) {
      var variant = findVariant();
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);

      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      if (stockMsg) {
        stockMsg.classList.remove('in-stock', 'low-stock', 'out-stock');
        if (!variant.available) {
          stockMsg.textContent = 'Out of stock';
          stockMsg.classList.add('out-stock');
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        } else {
          stockMsg.textContent = 'In stock, ready to ship';
          stockMsg.classList.add('in-stock');
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to cart';
          }
        }
      }

      if (!isInitialLoad && variant.featured_image && galleryEl) {
        var mainImg = galleryEl.querySelector('[data-gallery-main-img]');
        if (mainImg) mainImg.src = variant.featured_image.src;

        galleryEl.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          var tVariantId = t.getAttribute('data-variant-id');
          t.classList.toggle('active', tVariantId && String(tVariantId) === String(variant.id));
        });
      }
    }

    /* Radio button changes update everything */
    form.querySelectorAll('input[type="radio"][data-option-index]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateUI(false);
      });
    });

    /* Clicking a gallery photo tied to a variant selects that variant too */
    if (galleryEl) {
      galleryEl.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var vId = thumb.getAttribute('data-variant-id');
          if (!vId) return;
          var match = findVariantById(vId);
          if (!match) return;
          selectRadiosForVariant(match);
          updateUI(false);
        });
      });
    }

    updateUI(true);
  });

  /* Sticky add-to-cart bar */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAddBtn = document.querySelector('[data-add-to-cart-btn]');

  if (stickyBar && mainAddBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-40% 0px 0px 0px' });

    observer.observe(mainAddBtn);

    var stickyBtn = stickyBar.querySelector('[data-sticky-add-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAddBtn.click();
        mainAddBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

});